import React, { FC, useState } from 'react';
import { HandPhases } from '@/pages/table/components/BetSlider/BetSlider';
import Button, { ButtonVariants } from '@/components/new-design/Button';
import { twMerge } from 'tailwind-merge';
import useRaiseButtons from '@/pages/table/hooks/useRaiseButtons';

import styles from './QuickActionButtons.module.css';

interface RaiseButtonsProps {
  currentBet: number;
  max: number;
  pot: number;
  min: number;
  bigBlindValue: number;
  handPhase: HandPhases;
  showAllIn: boolean;
  isPlayerTurn: boolean;
  onChange: (value: number) => void;
  setShowBetSlider: (value: boolean) => void;
}
const QuickActionButtons: FC<RaiseButtonsProps> = ({
  currentBet,
  max,
  pot,
  min,
  bigBlindValue,
  handPhase,
  showAllIn,
  isPlayerTurn,
  onChange,
  setShowBetSlider,
}) => {
  const [activeLabel, setActiveLabel] = useState('');

  const { buttonsToShow } = useRaiseButtons({
    max,
    currentBet,
    pot,
    bigBlindValue,
    handPhase,
    showAllIn,
  });

  const getNewValue = (value: number) => (value > max ? max : value < min ? min : value);

  if (!buttonsToShow) {
    return null;
  }

  return (
    <div className={twMerge('flex w-full justify-end gap-1', !isPlayerTurn ? 'invisible' : '')}>
      {buttonsToShow.map((buttonItem) => (
        <Button
          key={buttonItem.label}
          onClick={() => {
            const newValue = getNewValue(buttonItem.bet);
            onChange(newValue);
            setShowBetSlider(true);
            setActiveLabel(buttonItem.label);
          }}
          variant={ButtonVariants.transparentWithBorder}
          className={twMerge(
            styles.button,
            buttonItem.label === activeLabel && styles.buttonActive,
            '!h-[1.5em] !w-[6.05em] !rounded-lg',
            'whitespace-nowrap !text-ph-white hover:!border-ph-gray-white hover:!text-ph-gray-white',
          )}
          textClassName="!text-xs"
        >
          {buttonItem.label}
        </Button>
      ))}
    </div>
  );
};

export default QuickActionButtons;
